import React from "react";
import Svg from "./circularProgress.styles";
import { useSvgCircleProgress } from "./useSvgCircleProgress";

const CircularProgress = ({ percent, label, account }) => {
  let percentNumber = parseInt(percent);
  const concatenatedPercent = Math.trunc(percentNumber);
  const radius = 42.5;
  const [ref, style] = useSvgCircleProgress(percentNumber, radius);
  
  const isLineOfCredit = account.accountType === "LOC";
  const hasAvailableCredit = account.availableCredit >= 0;
  let progressPercentageY = isLineOfCredit 
    ? "70"
    : "66";

  return (
    <Svg
      className="circular-progress"
      width="95"
      height="95"
      viewBox="0 0 95 95"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="47.5" cy="47.5" r={radius} className="outline-circle" />
      <circle
        cx="47.5"
        cy="47.5"
        r={radius}
        className="progress-circle"
        ref={ref}
        style={style}
      />
      <text className="label">
        {isLineOfCredit && (
          <>
            {hasAvailableCredit && (
              <>
                <tspan x="49%" y="34.707" fontSize={"12px"}>
                  {label.available.toUpperCase()}
                </tspan>
                <tspan x="49%" y="46.707" fontSize={"12px"}>
                  {label.credit.toUpperCase()}
                </tspan>
              </>
            )}
            {!hasAvailableCredit && (
              <>
                <tspan x="49%" y="30.707" fontSize={"16px"} fontWeight={"bold"}>
                  {label.over}
                </tspan>
                <tspan x="49%" y="50.707" fontSize={"16px"} fontWeight={"bold"}>
                  {label.the.toLowerCase()}
                </tspan>
                <tspan x="49%" y="70.707" fontSize={"16px"} fontWeight={"bold"}>
                  {label.limit}
                </tspan>
              </>
            )}
          </>
        )}
        {!isLineOfCredit && (
          <tspan x="50%" y="41.707">
            {label.repaid.toUpperCase()}
          </tspan>
        )}
      </text>
        {!(isLineOfCredit && !hasAvailableCredit) ? (
          <text className="progress">
            <tspan x="50%" y={progressPercentageY}>
              {concatenatedPercent}
              <tspan className="percent">%</tspan>
            </tspan>
          </text>
        ) : (
          <></>
        )}
      </Svg>
  );
};

export default CircularProgress;
